export const simpleEventsKeys = ['24', '25', '26', '12'];
